<template>
	<v-container>
		<v-layout mb-4 px-3>
			<v-flex xs12>
				<v-flex xs12>
					<h3>Posición</h3>
				</v-flex>
				<v-text-field
					type="number"
					solo
					hide-details
					v-if="resource.templateLanguages"
					v-model="resource.templateLanguages.position"
					@input="itWasUpdated"
				/>
				<v-text-field
					type="number"
					solo
					hide-details
					v-else
					v-model="newPosition"
				/>
			</v-flex>
		</v-layout>
		<v-layout mb-4 wrap px-3>
			<v-flex xs12>
				<h3>Nombre</h3>
			</v-flex>
			<v-flex xs12 d-flex align-center mb-3
				v-for="(lang, indexLang) in resource.templateLanguagesArray"
				:key="indexLang"
			>
				<v-flex xs4>{{lang.id}}</v-flex>
				<v-flex xs8>
					<v-text-field
						solo
						hide-details
						v-model="lang.name"
						@input="itWasUpdated"
					/>
				</v-flex>
			</v-flex>
		</v-layout>
		<v-layout px-3 wrap>
			<v-flex xs12>
				<h3>Ícono</h3>
			</v-flex>
			<v-flex xs12 d-flex align-center>
				<v-flex xs4>
					<upload-image
						label-ref="up"
						label-for="image"
						input-id="image"
						@send-image="getImage"
					/>
				</v-flex>
				<v-flex xs8>
					<v-text-field
						solo
						hide-details
						class="ml-2"
						v-model="resource.pathIcon"
						@input="itWasUpdated"
					/>
				</v-flex>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="$v.$invalid"
				@accept-button-clicked="$emit('save-data', resource, newPosition)"
				@cancel-button-clicked="$emit('close-modal')"
			/>
		</section>
	</v-container>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import uploadImage from '@/components/shared/upload-image';

function created() {
	this.codeProject = this.$route.params.codeProject;
}

function getImage(img) {
	this.$emit('set-image', img);
}

function itWasUpdated() {
	this.$emit('item-edited');
}

function validations() {
	return {
		resource: {
			pathIcon: { required },
			position: { required },
			templateLanguagesArray: {
				$each: {
					name: { required },
				},
			},
		},
	};
}

function data() {
	return {
		codeProject: '',
		position: 0,
		newPosition: null,
	};
}

export default {
	name: 'resource-configuration',
	components: {
		uploadImage,
	},
	created,
	data,
	methods: {
		getImage,
		itWasUpdated,
	},
	props: {
		resource: {
			default: () => {},
			type: Object,
		},
	},
	validations,
};
</script>




// WEBPACK FOOTER //
// src/components/resources/resource-configuration.vue